const keyBoardCharRegex = /^[a-zA-Z0-9~`!@#$%^&*()_+-={}|:;<>,.?\/'\s]+$/;
export function validateNonUSKeyBoardCharacters(value: string) : boolean {
    return keyBoardCharRegex.test(value);
} 